import type { ResolvedSound, SoundSetting } from "@loot-os/api-contract";

export interface SoundRowState {
  label: "Custom" | "Platform default" | "Same as …" | "Turned off" | "Silent";
  url?: string;
  gainDb: number;
  canRevert: boolean;
}

/**
 * What a row says about its event. `own` is the setting the page's own scope stored (the
 * environment's override, or on the platform page the platform's default); `resolved` is what
 * actually plays. The platform page never says "Platform default", since there is nothing
 * underneath it. `canRevert` is whether the scope has a setting of its own to remove: Revert on
 * the tenant page, Clear on the platform page.
 */
export function soundRowState(
  resolved: ResolvedSound | undefined,
  own?: SoundSetting,
  scope: "platform" | "tenant" = "tenant",
): SoundRowState {
  const canRevert = own !== undefined;
  if (!resolved) return { label: "Silent", gainDb: 0, canRevert };
  const { setting, source, via } = resolved;
  if ("off" in setting) return { label: "Turned off", gainDb: 0, canRevert };
  const base = { url: setting.url, gainDb: setting.gainDb ?? 0, canRevert };
  if (via) return { label: "Same as …", ...base };
  if (scope === "tenant" && source === "platform") return { label: "Platform default", ...base };
  return { label: "Custom", ...base };
}
